import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0092',
    ecrans: ['00-2']
});
